import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { content } from "@/data/content";

const LanguageContext = createContext(null);
const STORAGE_KEY = "hm-lang";

const detectInitial = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === "de" || stored === "en") return stored;
    const nav = (navigator.language || "de").toLowerCase();
    return nav.startsWith("de") ? "de" : "en";
  } catch {
    return "de";
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectInitial);

  const setLang = useCallback((next) => {
    setLangState(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* ignore */
    }
  }, []);

  const toggle = useCallback(() => {
    setLang(lang === "de" ? "en" : "de");
  }, [lang, setLang]);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t: content[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
